{
  "en": {
    "short": {
      "year": "numeric",
      "month": "numeric",
      "day": "numeric"
    },
    "long": {
      "year": "numeric",
      "month": "long",
      "day": "numeric",
      "weekday": "long",
      "hour": "numeric",
      "minute": "numeric"
    }
  },
  "fr": {
    "short": {
      "year": "numeric",
      "month": "numeric",
      "day": "numeric"
    },
    "long": {
      "year": "numeric",
      "month": "long",
      "day": "numeric",
      "weekday": "long",
      "hour": "numeric",
      "minute": "numeric"
    }
  },
  "nl": {
    "short": {
      "year": "numeric",
      "month": "numeric",
      "day": "numeric"
    },
    "long": {
      "year": "numeric",
      "month": "long",
      "day": "numeric",
      "weekday": "long",
      "hour": "numeric",
      "minute": "numeric"
    }
  }
}
